/* tslint:disable */
/* eslint-disable */
/**
 * Swagger Sites - OpenAPI 3.0
 * Sites
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface SiteCreateRequest {
    'name': string;
    'code': string;
    'codeFedid'?: string;
    'enabled'?: boolean;
    'provider': boolean;
    'externalId'?: string;
    'sapStructureNumber'?: string;
}
export interface SiteResponse {
    'name'?: string;
    'code'?: string;
    'codeFedid'?: string;
    'provider'?: boolean;
    'id'?: number;
}
export interface SiteUpdateRequest {
    'name'?: string;
    'code'?: string;
    'codeFedid'?: string;
    'provider'?: boolean;
}

/**
 * SitesApi - axios parameter creator
 */
export const SitesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a Site
         * @summary Create sites
         * @param {SiteCreateRequest} siteCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSite: async (siteCreateRequest: SiteCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteCreateRequest' is not null or undefined
            assertParamExists('createSite', 'siteCreateRequest', siteCreateRequest)
            const localVarPath = `/v1/sites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(siteCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete Site
         * @summary Delete Site
         * @param {number} siteId Id from site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSite: async (siteId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('deleteSite', 'siteId', siteId)
            const localVarPath = `/v1/sites/{site_id}`
                .replace(`{${"site_id"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get by fedid site code
         * @summary Get by fedid site code
         * @param {string} fedidSiteCode fedid site code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByFedidSiteCode: async (fedidSiteCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fedidSiteCode' is not null or undefined
            assertParamExists('getByFedidSiteCode', 'fedidSiteCode', fedidSiteCode)
            const localVarPath = `/v1/sites/fedid_site_code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fedidSiteCode !== undefined) {
                localVarQueryParameter['fedid_site_code'] = fedidSiteCode;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get All sites
         * @summary Get All sites
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSites: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/sites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Site
         * @summary Update Site
         * @param {number} siteId Id from site
         * @param {SiteUpdateRequest} siteUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSite: async (siteId: number, siteUpdateRequest: SiteUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('updateSite', 'siteId', siteId)
            // verify required parameter 'siteUpdateRequest' is not null or undefined
            assertParamExists('updateSite', 'siteUpdateRequest', siteUpdateRequest)
            const localVarPath = `/v1/sites/{site_id}`
                .replace(`{${"site_id"}}`, encodeURIComponent(String(siteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(siteUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SitesApi - functional programming interface
 */
export const SitesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SitesApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a Site
         * @summary Create sites
         * @param {SiteCreateRequest} siteCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSite(siteCreateRequest: SiteCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SiteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSite(siteCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SitesApi.createSite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete Site
         * @summary Delete Site
         * @param {number} siteId Id from site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSite(siteId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SiteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSite(siteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SitesApi.deleteSite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get by fedid site code
         * @summary Get by fedid site code
         * @param {string} fedidSiteCode fedid site code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByFedidSiteCode(fedidSiteCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SiteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByFedidSiteCode(fedidSiteCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SitesApi.getByFedidSiteCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get All sites
         * @summary Get All sites
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSites(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SiteResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSites(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SitesApi.getSites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update Site
         * @summary Update Site
         * @param {number} siteId Id from site
         * @param {SiteUpdateRequest} siteUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSite(siteId: number, siteUpdateRequest: SiteUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SiteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSite(siteId, siteUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SitesApi.updateSite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SitesApi - factory interface
 */
export const SitesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SitesApiFp(configuration)
    return {
        /**
         * Create a Site
         * @summary Create sites
         * @param {SiteCreateRequest} siteCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSite(siteCreateRequest: SiteCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<SiteResponse> {
            return localVarFp.createSite(siteCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete Site
         * @summary Delete Site
         * @param {number} siteId Id from site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSite(siteId: number, options?: RawAxiosRequestConfig): AxiosPromise<SiteResponse> {
            return localVarFp.deleteSite(siteId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get by fedid site code
         * @summary Get by fedid site code
         * @param {string} fedidSiteCode fedid site code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByFedidSiteCode(fedidSiteCode: string, options?: RawAxiosRequestConfig): AxiosPromise<SiteResponse> {
            return localVarFp.getByFedidSiteCode(fedidSiteCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Get All sites
         * @summary Get All sites
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSites(options?: RawAxiosRequestConfig): AxiosPromise<Array<SiteResponse>> {
            return localVarFp.getSites(options).then((request) => request(axios, basePath));
        },
        /**
         * Update Site
         * @summary Update Site
         * @param {number} siteId Id from site
         * @param {SiteUpdateRequest} siteUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSite(siteId: number, siteUpdateRequest: SiteUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<SiteResponse> {
            return localVarFp.updateSite(siteId, siteUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SitesApi - object-oriented interface
 */
export class SitesApi extends BaseAPI {
    /**
     * Create a Site
     * @summary Create sites
     * @param {SiteCreateRequest} siteCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createSite(siteCreateRequest: SiteCreateRequest, options?: RawAxiosRequestConfig) {
        return SitesApiFp(this.configuration).createSite(siteCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete Site
     * @summary Delete Site
     * @param {number} siteId Id from site
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteSite(siteId: number, options?: RawAxiosRequestConfig) {
        return SitesApiFp(this.configuration).deleteSite(siteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get by fedid site code
     * @summary Get by fedid site code
     * @param {string} fedidSiteCode fedid site code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getByFedidSiteCode(fedidSiteCode: string, options?: RawAxiosRequestConfig) {
        return SitesApiFp(this.configuration).getByFedidSiteCode(fedidSiteCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get All sites
     * @summary Get All sites
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSites(options?: RawAxiosRequestConfig) {
        return SitesApiFp(this.configuration).getSites(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update Site
     * @summary Update Site
     * @param {number} siteId Id from site
     * @param {SiteUpdateRequest} siteUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateSite(siteId: number, siteUpdateRequest: SiteUpdateRequest, options?: RawAxiosRequestConfig) {
        return SitesApiFp(this.configuration).updateSite(siteId, siteUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



